import React from 'react';
import styles from '../styles.module.scss';
import renderCenteredContent from './renderCenteredContent';
import { CmhcFlexIcon } from '@cmhc-schl/hearth-ui';

export const renderNoResultsState = (label: string, bodyContent: string) =>
  renderCenteredContent(
    <CmhcFlexIcon
      className={styles.transparentIcon}
      type="icon_docsearch"
      fill="transparent"
      aria-label={label}
      width={60}
      height={60}
    />,
    label,
    bodyContent
  );

export const renderEmptyDataState = (label: string, bodyContent: string) =>
  renderCenteredContent(
    <CmhcFlexIcon
      className={styles.transparentIcon}
      type="icon_check_circle_colored"
      fill="transparent"
      aria-label={label}
      width={60}
      height={60}
    />,
    label,
    bodyContent
  );
